module.exports = __webpack_public_path__ + "static/media/op-logo.775a749a.png";